export default {"src":"/_next/static/media/health-care.9a93d698.svg","height":44,"width":44};